import React from "react";

const Impressum = () => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "8px",
        maxHeight: "70vh",
        overflowY: "auto",
      }}
    >
      <h2 style={{ fontSize: "24px", color: "#007bff", marginBottom: "20px" }}>
        Imprint
      </h2>

      <p>Oleg Shitsel</p>
      <p>Graf-Sponeck-Str.1</p>
      <p>28327 Bremen, Germany</p>

      <p>
        <strong>E-Mail:</strong> olegs@bambkuss.com
      </p>
      <p>
        <strong>Phone:</strong> +49 1573 1385296
      </p>

      <h3 style={{ fontSize: "18px", color: "#007bff", marginTop: "20px" }}>
        Note on online dispute resolution
      </h3>
      <p>
        The EU Commission has provided an internet platform for the out-of-court
        online resolution of disputes (“ODR platform”) in relation to online
        contracts. The ODR platform can be accessed via the following link:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#007bff" }}
        >
          https://ec.europa.eu/consumers/odr
        </a>
      </p>
    </div>
  );
};

export default Impressum;
